import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { MenuList,MenuItem,Paper } from '@mui/material'
import ContextMenu from './ContextMenu'
import {
  DeleteWorkflowGroup,
  RenameWorkflowGroup,
  NewWorkflowGroup,
  NewTemplateWizard} from "./WorkflowGroupActions"
import { useDispatch, useSelector } from 'react-redux';
import newTemplateSlice, { newTemplateActions } from '../../redux/slices/newTemplateSlice';
import { useEffect } from 'react';
import NewWorkflowWizard from './WorkflowGroupActions/NewWorkflowWizard';
import UploadTemplate from './WorkflowGroupActions/UploadTemplate';
import { CopyWorkflowGroup } from './WorkflowGroupActions/CopyWorkflowGroup';

// const WG_MODALS = {
//   MNU_NEW_WF_GROUP: 'MNU_NEW_WF_GROUP',
//   MNU_REN_SEL_WF_GROUP: 'MNU_REN_SEL_WF_GROUP',
//   MNU_DEL_SEL_WF_GROUP: 'MNU_DEL_SEL_WF_GROUP',
//   MNU_NEW_TEM_WIZ: 'MNU_NEW_TEM_WIZ'
// };

function WfgContextMenu({ targetId }) {
  const { t } = useTranslation();
  const dispatch = useDispatch()
  const [openModal, setOpenModal] = useState(false);
  const [wfgmodalOpen, setwfgModalOpen] = useState(false);
  const [newTemplateWizardModalState, setNewTemplateWizardModalState] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [workflowWizardModal, setWorkflowWizardModal] = useState(false)
  const [uploadTemplateModal, setUploadTemplateModal] = useState(false);
  const [copyWfgModal, setCopyWfgModal] = useState(false);
  const newTemplate = useSelector((state) => state.newTemplate);
  const { currentScreen } = useSelector(state => state.treeData)
  const handleWfgModalClick = () => {
    setwfgModalOpen(!wfgmodalOpen);
  }
  const openRenameWFGModal = (e) => {
    setOpenModal(!openModal);
  }
  const openDeleteWFGModal = () => {
    setDeleteModal(!deleteModal);
  }
  const handleNewTemplateWizard = () => {
    setNewTemplateWizardModalState(true)
    // dispatch(newTemplateActions.setModalOpen(true));
  }
  const openUploadTemplateModal = () => {
    setUploadTemplateModal(!uploadTemplateModal);
  }
  const handleNewWorkflowWizard = () => {
    setWorkflowWizardModal(true)
  }
  const openCopyWFGModal = (e) => {
    setCopyWfgModal(true)
  }
  return (
    <>
      <ContextMenu targetId={targetId}>
        <Paper style={{ width: '19rem' }}>
        <MenuList vertical='true' >
          <MenuItem
            name={t('MNU_NEW_WF_GROUP')}
            onClick={handleWfgModalClick}
            //onClick={handleWfgModal(WG_MODALS.MNU_NEW_WF_GROUP)}
          >
            <span className={'RECORD'}></span>
            <span className={'margin-left-8'}>{t('MNU_NEW_WF_GROUP')}</span>
          </MenuItem>
          <MenuItem
            name={t('MNU_REN_SEL_WF_GROUP')}
            onClick={(e) => { openRenameWFGModal(e) }}
            //onClick={handleWfgModal(WG_MODALS.MNU_REN_SEL_WF_GROUP)}
          >
            <span className={'RENAME_WORKFLOW_GROUP'}></span>
            <span className={'margin-left-8'} >{t('MNU_REN_SEL_WF_GROUP')}</span>
          </MenuItem>
          <MenuItem
            name={t('LBL_COPY_WFG')}
            onClick={(e) => { openCopyWFGModal(e) }}
          >
            <span className={'COPY_WORKFLOW_GROUP'}></span>
            <span className={'margin-left-8'} >{t('LBL_COPY_WFG')}</span>
          </MenuItem>
          <MenuItem
            name={t('MNU_DEL_SEL_WF_GROUP')}
            onClick={openDeleteWFGModal}
            //onClick={handleWfgModal(WG_MODALS.MNU_DEL_SEL_WF_GROUP)}
          >
            <span className={'DELETE_WORKFLOW_GROUP'}></span>
            <span className={'margin-left-8'}>{t('MNU_DEL_SEL_WF_GROUP')}</span>
          </MenuItem>
          <MenuItem
            name={t('MNU_DEL_SEL_WF_GROUP')}
            onClick={openUploadTemplateModal}
          >
            <span className={'UPLOAD_TEMPLATE'}></span>
            <span className={'margin-left-8'}>{t('LBL_UPLOAD_TEMP')}</span>
          </MenuItem>
          {currentScreen !== 'workflow' && (<MenuItem
            name={t('MNU_NEW_TEM_WIZ')}
            onClick={handleNewTemplateWizard}
            //onClick={handleWfgModal(WG_MODALS.MNU_NEW_TEM_WIZ)}
          >
            <span className={'WIZARD'}></span>
            <span className={'margin-left-8'}>{t('MNU_NEW_TEM_WIZ')}</span>
          </MenuItem>)}
          {currentScreen === 'workflow' && (<MenuItem
            name={t('TIT_NEW_WF_WIZ')}
            onClick={handleNewWorkflowWizard}>
            <span className={'WIZARD'}></span>
            <span className={'margin-left-8'}>{t('TIT_NEW_WF_WIZ')}</span>
          </MenuItem>)}
        </MenuList>
        </Paper>
      </ContextMenu>

      {/* <NewWorkflowGroup modalOpen={openModal === WG_MODALS.MNU_NEW_WF_GROUP} toggle={handleWfgModal(null)}/>
      <NewTemplateWizard modalOpen={openModal === WG_MODALS.MNU_NEW_TEM_WIZ} toggle={handleWfgModal(null)}/>
      <RenameWorkflowGroup openModal={openModal === WG_MODALS.MNU_REN_SEL_WF_GROUP} toggle={handleWfgModal(null)}/>
      <DeleteWorkflowGroup openModal={openModal === WG_MODALS.MNU_DEL_SEL_WF_GROUP} toggle={handleWfgModal(null)}/> */}
      <NewWorkflowGroup onClose={() => setwfgModalOpen(false)} modalOpen={wfgmodalOpen} toggle={handleWfgModalClick}></NewWorkflowGroup>
      { newTemplateWizardModalState && <NewTemplateWizard modalOpen={newTemplateWizardModalState} toggle={() => setNewTemplateWizardModalState(false)}/> }
      { workflowWizardModal && <NewWorkflowWizard modalOpen={workflowWizardModal} toggle={() => setWorkflowWizardModal(!workflowWizardModal)} />}  
      <RenameWorkflowGroup onClose={() => setOpenModal(false)} openModal={openModal} toggle={openRenameWFGModal}></RenameWorkflowGroup>
      <DeleteWorkflowGroup onClose={() => setDeleteModal(false)} openModal={deleteModal} toggle={openDeleteWFGModal}></DeleteWorkflowGroup>
      <UploadTemplate open={uploadTemplateModal} toggle={openUploadTemplateModal} />
      {copyWfgModal && <CopyWorkflowGroup openModal={copyWfgModal} onClose={() => setCopyWfgModal(false)} />}
    </>
  )
}

export default WfgContextMenu;